import { render, staticRenderFns } from "./SolicitacaoTable.vue?vue&type=template&id=2d72371a&scoped=true&lang=pug"
import script from "./SolicitacaoTable.vue?vue&type=script&lang=js"
export * from "./SolicitacaoTable.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoTable.vue?vue&type=style&index=0&id=2d72371a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72371a",
  null
  
)

export default component.exports